import { Stack, Typography } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { JSX } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FormRadioGroup, { FormRadioGroupRadioButton } from "../../../../../components/forms/form-radio-group/FormRadioGroup";
import { UICustomizationModeTypeEnum, UserFieldType } from "../UserFieldTypes";
import { CustomView } from "./CustomView";
import PresetView from "./PresetView";

export type PageVisibilityStepProps = {
    organizationID: number | undefined;
};

export default function PageVisibilityStep({
    organizationID
}: PageVisibilityStepProps): JSX.Element {
    const { t } = useTranslation();

    const {
        watch
    } = useFormContext<UserFieldType>();

    const [customizationType, hasUICustomizationSettings] = watch(["uiCustomizationMode", "hasUICustomizationSettings"]);

    const radioButtons: Array<FormRadioGroupRadioButton> = [{
        label: t("userEditor.steps.pageVisibility.customizationMode.allViews.title"),
        value: 0,
        disabled: hasUICustomizationSettings,
        tooltip: hasUICustomizationSettings ? t("userEditor.steps.pageVisibility.customizationMode.allViews.disabledTooltip").toString() : undefined
    }, {
        label: t("userEditor.steps.pageVisibility.customizationMode.preset.title"),
        value: 1,
        disabled: hasUICustomizationSettings,
        tooltip: hasUICustomizationSettings ? t("userEditor.steps.pageVisibility.customizationMode.preset.disabledTooltip").toString() : undefined
    }, {
        label: t("userEditor.steps.pageVisibility.customizationMode.custom.title"),
        value: 2
    }];

    return (
        <Stack sx={{
            height: 1
        }}>
            <FormRadioGroup
                name="uiCustomizationMode"
                radioButtons={radioButtons}
                direction="row"
                sx={{
                    marginLeft: 1
                }}
            />
            {customizationType === UICustomizationModeTypeEnum.None &&
                <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                        alignItems: "center",
                        padding: 2,
                        paddingTop: 1,
                        paddingBottom: 1
                    }}>
                    <InfoOutlined />
                    <Typography variant="body1">
                        {t("userEditor.steps.pageVisibility.customizationMode.allViews.description")}
                    </Typography>
                </Stack>

            }
            {customizationType === UICustomizationModeTypeEnum.Preset &&
                <PresetView organizationID={organizationID} />
            }
            {customizationType === UICustomizationModeTypeEnum.Custom &&
                <CustomView organizationID={organizationID} />
            }
        </Stack>
    );
}